import {
  AfterViewInit,
  Component,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InfinityScrollComponent } from '@app-components/common/infinity-scroll/infinity-scroll.component';
import { TransformEmailListItemContract } from '@app-types/api/email';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { EmailColumnsEnum } from '@app-types/enums/emailColumns';
import { EmailSelectCheckboxComponent } from '@app-components/email/email-select-checkbox/email-select-checkbox.component';
import { DatePipe, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { EmailReplyPipe } from '@app-pipes/emails/email-reply-pipe';
import { ReplyType } from '@app-types/enums/ReplyType';
import { MatIconButton } from '@angular/material/button';
import { NotesButtonComponent } from '@app-components/email/action-buttons/notes-button/notes-button.component';
import { MetaButtonComponent } from '@app-components/email/action-buttons/meta-button/meta-button.component';
import { EmailTagsComponent } from '@app-components/email/email-tags/email-tags.component';
import { FormatSizePipe } from '@app-pipes/format-size.pipe';
import { RetrySendingButtonComponent } from '@app-components/email/action-buttons/retry-sending-button/retry-sending-button.component';
import { MoveToDraftButtonComponent } from '@app-components/email/action-buttons/move-to-draft-button/move-to-draft-button.component';
import { SendingStateButtonComponent } from '@app-components/email/action-buttons/sending-state-button/sending-state-button.component';
import { EmailActionButtonsComponent } from '@app-components/email/email-action-buttons/email-action-buttons.component';
import { EmailState } from '@app-types/enums/email-state';
import { EMAIL_SENDING_STATE } from '@app-shared/constants/constants';
import { FormatSemicolonPipe } from '@app-pipes/format-semicolon-pipe';
import { EmailSelectAllCheckboxComponent } from '@app-components/email/email-select-all-checkbox/email-select-all-checkbox.component';
import { EmailsService } from '@app-services/emails/emails.service';
import { EmailsScrollService } from '@app-services/emails/emails-scroll.service';
import { EmailGroupListComponent } from '@app-components/email/email-group-list/email-group-list.component';
import { ButtonActionsService } from '@app-services/emails/button-actions/button-actions.service';
import { ActionsModalsService } from '@app-services/emails/button-actions/actions-modal.service';
import { ActionsService } from '@app-services/emails/button-actions/actions.service';
import { EmailsPageStateService } from '@app-services/emails/emails-page-state.service';
import { StarButtonComponent } from '@app-components/email/action-buttons/star-button/star-button.component';
import { ArchiveStateCellComponent } from '@app-components/email/archive-state-cell/archive-state-cell.component';

@Component({
  selector: 'app-emails-desktop',
  templateUrl: './emails-desktop.component.html',
  styleUrls: ['./emails-desktop.component.scss'],
  imports: [
    TranslateModule,
    InfinityScrollComponent,
    MatTable,
    MatSort,
    MatSortModule,
    MatNoDataRow,
    MatColumnDef,
    EmailSelectCheckboxComponent,
    MatHeaderCell,
    MatCell,
    MatHeaderCellDef,
    MatCellDef,
    NgClass,
    MatIcon,
    MatTooltip,
    EmailReplyPipe,
    MatIconButton,
    NotesButtonComponent,
    MetaButtonComponent,
    EmailTagsComponent,
    FormatSizePipe,
    RetrySendingButtonComponent,
    MoveToDraftButtonComponent,
    DatePipe,
    SendingStateButtonComponent,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    EmailActionButtonsComponent,
    FormatSemicolonPipe,
    EmailSelectAllCheckboxComponent,
    EmailGroupListComponent,
    StarButtonComponent,
    ArchiveStateCellComponent,
  ],
})
export class EmailsDesktopComponent implements AfterViewInit {
  public actionsModals: ActionsModalsService;
  public actions: ActionsService;

  @Output() sortData = new EventEmitter<Sort>();
  @Output() startRecording = new EventEmitter<MouseEvent>();
  @Output() finishRecording = new EventEmitter<{
    event: MouseEvent;
    email: TransformEmailListItemContract;
  }>();
  @Output() rightClick = new EventEmitter<{
    event: MouseEvent;
    email: TransformEmailListItemContract;
  }>();

  @ViewChild(InfinityScrollComponent) infinityScroll: InfinityScrollComponent;
  @ViewChild(MatSort) sort: MatSort;

  public EmailColumnsEnum = EmailColumnsEnum;
  public EmailState = EmailState;

  public sendingIcons = EMAIL_SENDING_STATE;
  public replyIcons: {
    [key in ReplyType]: string;
  } & {
    [key: number]: string;
  } = {
    [ReplyType.Reply]: 'reply',
    [ReplyType.ReplyAll]: 'reply_all_outline',
    [ReplyType.Forward]: 'shortcut',
  };

  constructor(
    protected emailsService: EmailsService,
    protected emailsScrollService: EmailsScrollService,
    protected buttonActionsService: ButtonActionsService,
    protected emailsPageStateService: EmailsPageStateService
  ) {
    this.actionsModals = buttonActionsService.actionsModals;
    this.actions = buttonActionsService.actions;
  }

  trackById(_: number, item: TransformEmailListItemContract): number {
    return item.emailId;
  }

  ngAfterViewInit(): void {
    this.emailsScrollService.emailsDesktopInfinityScroll = this.infinityScroll;
  }
}
